import React, { useState } from 'react';
import { LayoutDashboard, Package, FileText, Users, Activity, Settings, User, ChevronLeft, ChevronRight } from 'lucide-react';
export function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };
  return <div className={`${isCollapsed ? 'w-20' : 'w-64'} bg-white border-r border-gray-200 h-screen fixed left-0 top-0 transition-all duration-300 ease-in-out`} data-id="element-197">
      {/* Logo */}
      <div className="h-16 border-b border-gray-200 flex items-center px-6" data-id="element-198">
        <div className="flex items-center space-x-3" data-id="element-199">
          <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-200">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-201">
              <path d="M12 3.5C7.5 3.5 3.5 7.5 3.5 12c0 1.6.5 3.2 1.4 4.5l1.4-1.4c-.7-1-.9-2-.9-3.1 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5c-1.1 0-2.1-.3-3.1-.9l-1.4 1.4c1.3.9 2.9 1.4 4.5 1.4 4.4 0 8-3.6 8-8s-3.5-8-8-8z" fill="#7C3AED" data-id="element-202" />
              <path d="M12 8.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zm0 5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" fill="#E9D5FF" data-id="element-203" />
            </svg>
          </div>
          {!isCollapsed && <span className="text-lg font-semibold text-gray-900" data-id="element-204">Scoop</span>}
        </div>
      </div>
      {/* Navigation */}
      <nav className="px-4 pt-4" data-id="element-205">
        <div className="space-y-1" data-id="element-206">
          <a href="#" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg bg-purple-50 text-purple-600`} data-id="element-207">
            <LayoutDashboard className="w-5 h-5" data-id="element-208" />
            {!isCollapsed && <span data-id="element-209">Dashboard</span>}
          </a>
          <a href="#" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-600 hover:bg-gray-50`} data-id="element-210">
            <Package className="w-5 h-5" data-id="element-211" />
            {!isCollapsed && <span data-id="element-212">Products</span>}
          </a>
          <a href="#" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-600 hover:bg-gray-50`} data-id="element-213">
            <FileText className="w-5 h-5" data-id="element-214" />
            {!isCollapsed && <span data-id="element-215">Claims</span>}
          </a>
          <a href="#" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-600 hover:bg-gray-50`} data-id="element-216">
            <Users className="w-5 h-5" data-id="element-217" />
            {!isCollapsed && <span data-id="element-218">Suppliers</span>}
          </a>
          <a href="#" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-600 hover:bg-gray-50`} data-id="element-219">
            <Activity className="w-5 h-5" data-id="element-220" />
            {!isCollapsed && <span data-id="element-221">Activity</span>}
          </a>
        </div>
        {/* Bottom Section */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t" data-id="element-222">
          <div className="space-y-1" data-id="element-223">
            <a href="#" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-600 hover:bg-gray-50`} data-id="element-224">
              <Settings className="w-5 h-5" data-id="element-225" />
              {!isCollapsed && <span data-id="element-226">Settings</span>}
            </a>
            <a href="#" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-600 hover:bg-gray-50`} data-id="element-227">
              <User className="w-5 h-5" data-id="element-228" />
              {!isCollapsed && <span data-id="element-229">Profile</span>}
            </a>
          </div>
        </div>
      </nav>
      {/* Toggle Button */}
      <button onClick={toggleSidebar} className="absolute -right-3 top-20 bg-white border rounded-full p-1.5 hover:bg-gray-50" data-id="element-230">
        {isCollapsed ? <ChevronRight className="w-4 h-4 text-gray-600" data-id="element-231" /> : <ChevronLeft className="w-4 h-4 text-gray-600" data-id="element-232" />}
      </button>
    </div>;
}